import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { FeaturedAreas } from "@/components/FeaturedAreas";
import { HomeValuation } from "@/components/HomeValuation";
import { Listings } from "@/components/Listings";
import { AreaAlertSection } from "@/components/AreaAlert";
import { ModernServices } from "@/components/ModernServices";
import { Quiz } from "@/components/Quiz";
import { Bio } from "@/components/Bio";
import { Reviews } from "@/components/Reviews";
import { Contact, Footer } from "@/components/Contact";

export default function Landing() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <FeaturedAreas />
        <HomeValuation />
        <AreaAlertSection />
        <Listings />
        <ModernServices />
        <Quiz />
        <Bio />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
